import { FC, useEffect } from 'react';
import TableCard from '@/components/Tables/TableCard/TableCard';
import { useSTKContext } from '@/context/context';
import { StoresTabItemProps, RowWithStoreGroupCount } from './StoresTabItemProps.types';
import styles from './StoresTabItem.module.css';
import { Store } from '@/types/stores.types';
import { useTranslation } from 'react-i18next';
import Link from '@/components/Link/Link';
import _ from 'lodash/';

const ViewMenu = ({ rowWrapper, countByStoreGroup, storeLinkTo }: RowWithStoreGroupCount) => {
  const { setStoresAndGroups } = useSTKContext();
  const { row } = rowWrapper;
  const linkTo = storeLinkTo ?? `/menus/${row.original.storeNo}`;
  return (
    <Link
      onClick={() =>
        setStoresAndGroups({
          origin: 'tab-store',
          stores: [
            {
              storeNo: row.original.storeNo,
              storeGroup: row.original.groupName,
            },
          ],
          countByStoreGroup,
        })
      }
      to={linkTo}
    >
      {row.original.storeNo}
    </Link>
  );
};

const StoresTabItem: FC<StoresTabItemProps> = ({
  stores,
  isLoading,
  selectedRows,
  setSelectedRows,
  onStoresSelectionChange,
  storeLinkTo,
}) => {
  const { t } = useTranslation();
  const storesByGroups = _.groupBy(stores, 'groupName');
  const countByStoreGroup = Object.entries(storesByGroups).map(([groupName, storeArray]) => ({
    storeGroup: groupName,
    count: storeArray.length,
  }));

  useEffect(() => {
    const keys = Object.keys(selectedRows);
    const storeList: string[] = [];
    keys.forEach((key) => {
      storeList.push(stores[key as never]?.storeNo);
    });
    onStoresSelectionChange?.(storeList);
  }, [selectedRows]);

  return (
    <TableCard
      className={styles.cardWidth}
      enableRowSelection
      selectedRows={selectedRows}
      includeMinWidth={false}
      enableFilters
      returnedRecordsText={(count) => t('menu.table.returnedRecord', { count })}
      isLoading={isLoading}
      data={stores}
      columns={[
        {
          header: t('menu.table.storeId'),
          accessorKey: 'storeNo',
          enableSorting: true,
          cell: (rowWrapper) => (
            <ViewMenu rowWrapper={rowWrapper} countByStoreGroup={countByStoreGroup} storeLinkTo={storeLinkTo} />
          ),
        },
        {
          header: t('menu.table.address'),
          accessorFn: (row: Store) => `${row.address}, ${row.city} ${row.state} ${row.zip}`,
          enableSorting: true,
        },
      ]}
      onRowSelectionChange={setSelectedRows}
    />
  );
};

export default StoresTabItem;
